/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many milliliters are in a cup?`)
};

const es_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos mililitros hay en una taza?`)
};

const de_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Milliliter hat ein Cup?`)
};

const nl_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel milliliter zit er in een kopje?`)
};

const fr_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de millilitres y a-t-il dans une tasse ?`)
};

const it_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti millilitri ci sono in una tazza?`)
};

const pt_br2_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos mililitros tem em um copo?`)
};

const pt_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos mililitros existem numa chávena?`)
};

const ja_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カップには何ミリリットルありますか?`)
};

const zh_uc_vol_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_vol_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_vol_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_vol_faq2_q", locale)
	if (locale === "en") return en_uc_vol_faq2_q(inputs)
	if (locale === "es") return es_uc_vol_faq2_q(inputs)
	if (locale === "de") return de_uc_vol_faq2_q(inputs)
	if (locale === "nl") return nl_uc_vol_faq2_q(inputs)
	if (locale === "fr") return fr_uc_vol_faq2_q(inputs)
	if (locale === "it") return it_uc_vol_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_vol_faq2_q(inputs)
	if (locale === "pt") return pt_uc_vol_faq2_q(inputs)
	if (locale === "ja") return ja_uc_vol_faq2_q(inputs)
	return zh_uc_vol_faq2_q(inputs)
};